import React from 'react'
import ReacctDOM from 'react-dom';

import App from './components/App';

ReacctDOM.render(<App />, document.getElementById('root'));